import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setPassword } from '../api';

export default function ConfirmPassword() {
  const [form, setForm]   = useState({ password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await setPassword(form);
      setSuccess('Password set successfully. Redirecting...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed.');
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <div className="card shadow-lg border-0" style={{ width: 400, borderRadius: '1rem', overflow: 'hidden' }}>
        <div className="card-header bg-white border-0 text-center pt-5 pb-2">
          <div className="bg-warning text-white d-inline-flex justify-content-center align-items-center mb-3 shadow-sm" style={{ width: 64, height: 64, borderRadius: '50%' }}>
            <i className="bi bi-shield-lock fs-3" />
          </div>
          <h4 className="fw-bold text-dark mb-0">Set Password</h4>
          <p className="text-secondary small mt-1">Please set your new password</p>
        </div>
        <div className="card-body px-4 pb-5 pt-0">
          {error   && <div className="alert alert-danger  py-2 small fw-medium text-center rounded-3">{error}</div>}
          {success && <div className="alert alert-success py-2 small fw-medium text-center rounded-3">{success}</div>}
          <form onSubmit={handleSubmit} className="mt-3">
            <div className="mb-3">
              <label className="form-label fw-medium text-secondary small mb-1">New Password</label>
              <input className="form-control form-control-lg fs-6" type="password" placeholder="••••••••••••" value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            </div>
            <div className="mb-4">
              <label className="form-label fw-medium text-secondary small mb-1">Confirm Password</label>
              <input className="form-control form-control-lg fs-6" type="password" placeholder="••••••••••••" value={form.confirmPassword}
                onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))} />
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-primary btn-lg flex-fill fs-6 fw-semibold py-2">Set Password</button>
              <button type="button" className="btn btn-light border btn-lg fs-6 fw-semibold py-2" onClick={() => navigate('/login')}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
